import React, { useEffect, useState } from 'react'
import { Container, FlexColumn, FlexRow } from 'components/common/Containers'
import LandingItem from './components/LandingItem/LandingItem'
import styles from './Landing.module.scss'
import Input from 'components/common/Input/Input'
import { Select } from 'components/common/Select'
import { Button } from 'components/common/Buttons/Button'
import { useRouter } from 'next/router'
import { RouteEnum } from 'enums/RouteEnum'
import { useGetUser } from 'hooks/useGetUser'
import { notificationController } from 'notificationController/notificationController'

const limitOptions = [
  {
    label: '5',
    value: '5',
  },
  {
    label: '10',
    value: '10',
  },
  {
    label: '15',
    value: '15',
  },
  {
    label: '20',
    value: '20',
  },
  {
    label: '25',
    value: '25',
  },
  {
    label: '50',
    value: '50',
  },
  {
    label: '100',
    value: '100',
  },
  {
    label: '200',
    value: '200',
  },
]

interface Props {
  data: {
    title: string
    description: string
    benefits: string[]
    image: string
  }[]
}

const Landing: React.FC<Props> = ({ data }) => {
  const router = useRouter()
  const { data: user } = useGetUser()
  const [showSearch, setShowsearch] = useState<boolean>(true)

  const hiddenSearchRoutes:RouteEnum[] = [
    RouteEnum.TOOLS_SEARCH_ALL_REGISTERED_DOMAINS,
  ]

  const handleSearch = () => {
    if (!user) {
      notificationController.show({
        description: 'You need to login to access this feature.',
        status: 'error',
      })

      router.push(`${RouteEnum.LOGIN}/?from=${router.pathname}`)
    }
  }

  useEffect(() => {
    if (hiddenSearchRoutes.includes(router.asPath as RouteEnum)) {
      setShowsearch(false)
    }
  }, [router])

  return (
    <section className={styles.page}>
      {showSearch && (
        <Container>
          <div className={styles.topFilterWrapper}>
            <div className={styles.inputWrapper}>
              <Input
                placeholder="Enter a valid domain name e.g. dailynews.com"
                isFormik={false}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleSearch()
                  }
                }}
              />
              <Button
                size="sm"
                className={styles.button}
                onClick={handleSearch}
              >
                Search
              </Button>
            </div>

            <FlexRow gap="25px" align="center">
              Limit
              <Select options={limitOptions} />
            </FlexRow>
          </div>
        </Container>
      )}

      <Container className={styles.containerOverflowHidden}>
        <FlexColumn className={styles.row} align="normal" gap="0px">
          {data.map((el, i) => (
            <LandingItem
              key={el.title}
              title={el.title}
              description={el.description}
              benefits={el.benefits}
              imgSrc={el.image}
              layout={i % 2 === 0 ? 'imgRight' : 'imgLeft'}
            />
          ))}
        </FlexColumn>
      </Container>
    </section>
  )
}

export default Landing
